const routes = [
  {
    path: '/counter',
    name: 'Counter',
    component: () => import('@/layout/counter.vue'),
    children: [
      {
        path: '/counter/ordercashier',
        component: () => import('@/views/counter/order-cashier.vue'),
      }, // 订单收银台
      {
        path: '/counter/withdrawal',
        component: () => import('@/views/counter/withdrawal/index.vue'),
      }, // 提现
      {
        path: '/counter/deposit',
        component: () => import('@/views/counter/deposit/index.vue'),
      }, // 存款
      {
        path: '/counter/payment-account/type-list',
        component: () => import('@/views/counter/payment-account/type-list.vue'),
      }, // 支付账户类型列表
      {
        path: '/counter/payment-account/list',
        component: () => import('@/views/counter/payment-account/list.vue'),
      }, // 支付账户列表
      {
        path: '/counter/payment-account/add',
        component: () => import('@/views/counter/payment-account/add.vue'),
      }, // 添加支付账户
      {
        path: '/counter/payment-account/type-all',
        component: () => import('@/views/counter/payment-account/type-all.vue'),
      }, // 支付账户全部类型列表
      {
        path: '/counter/protocol',
        component: () => import('@/views/counter/protocol.vue'),
      }, // 协议
      {
        path: '/counter/tutorial',
        component: () => import('@/views/counter/tutorial/index.vue'),
      }, // 教程
      {
        path: '/counter/tutorial/deposit',
        component: () => import('@/views/counter/tutorial/details.vue'),
      }, // 教程详情
      {
        path: '/counter/tutorial/withdrawal',
        component: () => import('@/views/counter/tutorial/details.vue'),
      }, // 提现教程详情
      {
        path: '/counter/payment-loading',
        component: () => import('@/views/counter/payment-loading.vue'),
      }, // 支付加载中
    ],
  },

  {
    path: '/wallet',
    name: 'Wallet',
    component: () => import('@/layout/wallet.vue'),
    children: [
      {
        path: '/wallet/forget-password',
        component: () => import('@/views/wallet/forget-password/index.vue'),
      }, // 忘记密码
      {
        path: '/wallet/automatic-password-recovery',
        component: () => import('@/views/wallet/forget-password/automatic-password-recovery.vue'),
      }, // 忘记密码步骤
      {
        path: '/wallet/realname',
        component: () => import('@/views/wallet/realname/index.vue'),
      }, // 实名认证
      {
        path: '/wallet/realname-info',
        component: () => import('@/views/wallet/realname/info.vue'),
      }, // 实名认证信息
      {
        path: '/wallet/bill',
        component: () => import('@/views/wallet/bill/index.vue'),
      }, // 账单列表【明细】
      {
        path: '/wallet/mine',
        component: () => import('@/views/wallet/mine-wallet/index.vue'),
        meta: {
          statusBarColor: '#ffffff',
        },
      }, // 我的钱包
      {
        path: '/wallet/business',
        component: () => import('@/views/wallet/business/index.vue'),
      }, // 买卖
      {
        path: '/wallet/setting-area',
        component: () => import('@/views/wallet/setting-area/index.vue'),
      },
      {
        path: '/wallet/tutorial',
        component: () => import('@/views/wallet/tutorial/index.vue'),
      }, // 使用教程
      {
        path: '/wallet/tutorial/detail',
        component: () => import('@/views/wallet/tutorial/detail.vue'),
      }, // 教程详情(买币/卖币等)
      {
        path: '/wallet/about',
        component: () => import('@/views/wallet/about/index.vue'),
      }, // 关于我们
      {
        path: '/wallet/about/terms',
        component: () => import('@/views/wallet/about/terms.vue'),
      }, // 服务条款
      {
        path: '/wallet/about/privacy',
        component: () => import('@/views/wallet/about/privacy.vue'),
      }, // 隐私条款
      {
        path: '/wallet/account-security',
        component: () => import('@/views/wallet/setting-area/account-security.vue'),
      },
      {
        path: '/wallet/reset-password',
        component: () => import('@/views/wallet/setting-area/reset-password.vue'),
      },
      {
        path: '/wallet/bind-phone',
        component: () => import('@/views/wallet/setting-area/bind-phone.vue'),
      },
      {
        path: '/wallet/safe-password',
        component: () => import('@/views/wallet/setting-area/safe-password.vue'),
      },
      {
        path: '/wallet/help-retrieve',
        component: () => import('@/views/wallet/setting-area/help-retrieve.vue'),
      },
      {
        path: '/wallet/payment-account/type-all',
        component: () => import('@/views/wallet/payment-account/type-all.vue'),
      }, // 支付账户全部类型列表
      {
        path: '/wallet/payment-account/type-list',
        component: () => import('@/views/wallet/payment-account/type-list.vue'),
      }, // 电子钱包通道列表
      {
        path: '/wallet/payment-account/add',
        component: () => import('@/views/wallet/payment-account/add.vue'),
      }, // 添加支付账户
      {
        path: '/wallet/payment-account/list',
        component: () => import('@/views/wallet/payment-account/list.vue'),
      }, // 支付账户列表
      {
        path: '/wallet/order-cashier',
        component: () => import('@/views/wallet/order-cashier.vue'),
      }, // 订单收银台
      {
        path: '/wallet/protocol',
        component: () => import('@/views/wallet/protocol.vue'),
      }, // 协议
      {
        path: '/wallet/transfer',
        component: () => import('@/views/wallet/transfer/index.vue'),
      }, // 转账
      {
        path: '/wallet/collection',
        component: () => import('@/views/wallet/collection/index.vue'),
      }, // 收款
      {
        path: '/wallet/exchange',
        component: () => import('@/views/wallet/exchange.vue'),
      }, // 兑换
    ],
  },
  {
    path: '/wallet-embedded',
    name: 'WalletEmbedded',
    component: () => import('@/layout/wallet-embedded.vue'),
    children: [
      {
        path: '/wallet-embedded/business',
        component: () => import('@/views/wallet/business/index.vue'),
      }, // 嵌入 买卖页面
      {
        path: '/wallet-embedded/payment-account/type-all',
        component: () => import('@/views/wallet/payment-account/type-all.vue'),
      }, // 支付账户全部类型列表
      {
        path: '/wallet-embedded/payment-account/type-list',
        component: () => import('@/views/wallet/payment-account/type-list.vue'),
      }, // 电子钱包通道列表
      {
        path: '/wallet-embedded/payment-account/add',
        component: () => import('@/views/wallet/payment-account/add.vue'),
      }, // 添加支付账户
      {
        path: '/wallet-embedded/payment-account/list',
        component: () => import('@/views/wallet/payment-account/list.vue'),
      }, // 支付账户列表
      {
        path: '/wallet-embedded/order-cashier',
        component: () => import('@/views/wallet/order-cashier.vue'),
      }, // 订单收银台
      {
        path: '/wallet-embedded/bill',
        component: () => import('@/views/wallet/bill/index.vue'),
      }, // 账单列表【明细】
      {
        path: '/wallet-embedded/protocol',
        component: () => import('@/views/wallet/protocol.vue'),
      }, // 协议
    ],
  },
  {
    path: '/cpay',
    component: () => import('@/views/cpay.vue'),
  }, // cpay外跳页面
  {
    path: '/maintainer',
    component: () => import('@/views/maintainer.vue'),
  },
];

// 不是生产环境才加载文档路由
if (import.meta.env.MODE !== 'production') {
  routes.push({
    path: '/docs/counter',
    component: () => import('@/views/docs/counter/index.vue'),
  });
  routes.push({
    path: '/docs/wallet',
    component: () => import('@/views/docs/wallet/index.vue'),
  });
  routes.push({
    path: '/docs/wallet-embedded',
    component: () => import('@/views/docs/wallet-embedded/index.vue'),
  });
  routes.push({
    path: '/docs/wallet-backend',
    component: () => import('@/views/docs/wallet-backend/index.vue'),
  });
  routes.push({
    path: '/docs/input-ecb',
    component: () => import('@/views/docs/input-ecb.vue'),
  });
}

export default routes;
